import { ChatMessageType } from "../pages/robot/training-chat/conversation/components/types";
import { Store } from "./store";
import {
  GeneratingStatus,
  StreamResponseDataType,
} from "../pages/robot/training-chat/conversation/components/streamFetch";
import { DialogItem } from "@/services/training-chat";
type Role = "human" | "ai";
type ChatHistory = {
  msg?: ChatMessageType;
  status: GeneratingStatus;
  role: Role;
  streamResponseData?: StreamResponseDataType[];
  messageId: string;
  /** 唯一id */
  messageUniqueId: string;
  positive?: boolean;
  /** 对应纠偏知识id */
  rectifyId?: string;
};
export interface TrainingChatStoreType {
  /** 当前机器人id */
  robotId?: string;
  /** 训练记录列表 */
  dialogsList: DialogItem[];
  /** 当前训练对话id */
  currentChatId?: string;
  /** 训练对话上下文 */
  histories: ChatHistory[];
  abortsMap: Map<string, AbortController>;
}

export const trainingChatStore = new Store<TrainingChatStoreType>(() => ({
  robotId: void 0,
  dialogsList: [],
  currentChatId: void 0,
  histories: [],
  abortsMap: new Map<string, AbortController>(),
}));
export const trainingChatStoreActions = {
  setRobotId(id?: string) {
    trainingChatStore.set({
      robotId: id,
    });
  },
  setDialogsList(payload?: DialogItem[]) {
    trainingChatStore.set({
      dialogsList: payload || [],
    });
  },
  addDialogsList(payload: DialogItem) {
    trainingChatStore.set({
      dialogsList: [payload, ...(trainingChatStore.get().dialogsList || [])],
    });
  },
  /** 对话列表的好评、差评、总回复数的增加,默认+1、-1 */
  updateDialogsStatistics(
    id: string,
    operate: "add" | "subtract",
    type: "numberOfAll" | "numberOfCP" | "numberOfHP",
    number: number = 1
  ) {
    const dialogsList = trainingChatStore.get().dialogsList;
    const newDialogsList = dialogsList.map((item) => {
      if (item.chatId === id)
        return {
          ...item,
          [type]: operate === "add" ? item[type] + number : item[type] - number,
        };
      return item;
    });
    trainingChatStore.set({
      dialogsList: newDialogsList,
    });
  },
  setCurrentChatId(id?: string) {
    trainingChatStore.set({
      currentChatId: id,
    });
  },
  setHistories(payload: ChatHistory[]) {
    trainingChatStore.set({
      histories: payload,
    });
  },
  pushHistories(payload: ChatHistory) {
    trainingChatStore.set({
      histories: [...trainingChatStore.get().histories, payload],
    });
  },
  updateHistoryStatus(messageId: string, payload: Partial<ChatHistory>) {
    const histories = trainingChatStore.get().histories;
    const newHistories = histories.map((item) => {
      if (item.messageId === messageId)
        return {
          ...item,
          ...payload,
        };
      return item;
    });
    trainingChatStore.set({
      histories: newHistories,
    });
  },
  updateRectifyIds(data: Record<string, string>) {
    const histories = trainingChatStore.get().histories;
    const newHistories = histories.map((item) => {
      if (Object.keys(data).includes(item.messageUniqueId))
        return { ...item, rectifyId: data[item.messageUniqueId] };
      return item;
    });
    trainingChatStore.set({ histories: newHistories });
  },
  clearHistories() {
    trainingChatStore.set({
      histories: [],
    });
  },
};
